import { GroupingFactorDataDriven } from "../ars_ldm";
import { isNamedObject } from "./isNamedObject";

/**
 * Type guard to check if a value is a GroupingFactorDataDriven.
 *
 * Validates that the object has the required properties of a GroupingFactorDataDriven:
 * - NamedObject properties
 * - id: string
 * - groupingDataset: string
 * - groupingVariable: string
 * - dataDriven: true
 * - dataValues: string[]
 *
 * @param obj - The value to check
 * @returns True if the object is a GroupingFactorDataDriven
 */
export const isGroupingFactorDataDriven = (obj: unknown): obj is GroupingFactorDataDriven => {
  // Check NamedObject properties
  if (!isNamedObject(obj)) return false;
  // Check required properties and their types
  const chkObj = obj as GroupingFactorDataDriven;
  if (chkObj.dataDriven !== true) return false;
  if (typeof chkObj.id !== "string") return false;
  if (typeof chkObj.groupingDataset !== "string") return false;
  if (typeof chkObj.groupingVariable !== "string") return false;
  if (!Array.isArray(chkObj.dataValues)) return false;
  if (chkObj.dataValues.some((v) => typeof v !== "string")) return false;
  // Everything is good
  return true;
};
